import React from 'react'

export const Medal = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 20 20'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path="url(#clip0_8179_63930)">
      <path d="M12 2C16.4183 2 20 5.58172 20 10C20 12.5264 18.8289 14.7793 17 16.2454V20.8557C17 21.6237 16.2329 22.1553 15.5138 21.8857L12 20.568L8.48624 21.8857C7.76711 22.1553 7 21.6237 7 20.8557V16.2454C5.17108 14.7793 4 12.5264 4 10C4 5.58172 7.58172 2 12 2ZM12 4C8.68629 4 6 6.68629 6 10C6 13.3137 8.68629 16 12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4ZM12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6Z"/>
    </g>
    <defs>
      <clipPath id="clip0_8179_63930">
        <rect width="25" height="25" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
